{
  "version": 1,
  "asset_id": "9fe12368-645a-48f2-a921-ba04aa077502",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/9fe12368-645a-48f2-a921-ba04aa077502/swatch-black.jpeg",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/9fe12368-645a-48f2-a921-ba04aa077502/swatch-black.jpeg",
  "original_filename": "swatch-black.jpeg",
  "size": 436816,
  "content_type": "image/jpeg",
  "created_at": "2026-08-02T15:18:20Z"
}
